export class Collection {
	id?: number;
	name?: string;
	startDate?: string;
	endDate?: string;

	constructor(init?: Partial<Collection>) {
		Object.assign(this, init);
	}
}
